export const ConflictsViewScenarioId = 'TimePanelConflictsView';
export const TaskScenarioId = 'TimePanel';
export const ToDoReferralSourcePrefix = 'MyDay';

export const TodoScenarioConfigSource = 'TimePanelTodo' as const;
